//moved from legacy transport order
export enum FreightMode {
  In = 'IN',
  Out = 'OUT',
  Unknown = 'UNKNOWN',
}
